"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BeastTyrantIcon_1 = __importDefault(require("./BeastTyrantIcon"));
var BerserkerIcon_1 = __importDefault(require("./BerserkerIcon"));
var BruteIcon_1 = __importDefault(require("./BruteIcon"));
var CragheartIcon_1 = __importDefault(require("./CragheartIcon"));
var DoomstalkerIcon_1 = __importDefault(require("./DoomstalkerIcon"));
var ElementalistIcon_1 = __importDefault(require("./ElementalistIcon"));
var MindthiefIcon_1 = __importDefault(require("./MindthiefIcon"));
var NightshroudIcon_1 = __importDefault(require("./NightshroudIcon"));
var PlagueheraldIcon_1 = __importDefault(require("./PlagueheraldIcon"));
var QuartermasterIcon_1 = __importDefault(require("./QuartermasterIcon"));
var SawbonesIcon_1 = __importDefault(require("./SawbonesIcon"));
var ScoundrelIcon_1 = __importDefault(require("./ScoundrelIcon"));
var SoothsingerIcon_1 = __importDefault(require("./SoothsingerIcon"));
var SpellweaverIcon_1 = __importDefault(require("./SpellweaverIcon"));
var SummonerIcon_1 = __importDefault(require("./SummonerIcon"));
var SunkeeperIcon_1 = __importDefault(require("./SunkeeperIcon"));
var TinkererIcon_1 = __importDefault(require("./TinkererIcon"));
exports.CharacterIcons = [react_1.default.createElement(BeastTyrantIcon_1.default, null), react_1.default.createElement(BerserkerIcon_1.default, null), react_1.default.createElement(BruteIcon_1.default, null), react_1.default.createElement(CragheartIcon_1.default, null), react_1.default.createElement(DoomstalkerIcon_1.default, null), react_1.default.createElement(ElementalistIcon_1.default, null), react_1.default.createElement(MindthiefIcon_1.default, null), react_1.default.createElement(NightshroudIcon_1.default, null), react_1.default.createElement(PlagueheraldIcon_1.default, null), react_1.default.createElement(QuartermasterIcon_1.default, null), react_1.default.createElement(SawbonesIcon_1.default, null), react_1.default.createElement(ScoundrelIcon_1.default, null), react_1.default.createElement(SoothsingerIcon_1.default, null), react_1.default.createElement(SpellweaverIcon_1.default, null), react_1.default.createElement(SummonerIcon_1.default, null), react_1.default.createElement(SunkeeperIcon_1.default, null), react_1.default.createElement(TinkererIcon_1.default, null)];



//////////////////
// WEBPACK FOOTER
// ./src/components/icons/Icons.tsx
// module id = 783
// module chunks = 0